import { AutocompleteMultiSelect } from '@shigo-ui/ui';

import { dashboardT } from '../../../../../lib/messages';
import { useTailoredSupplyReferences } from '../../hooks';
import type { TailoredSupplyDomainsFilter, TailoredSupplyReference } from '../../model';

interface TailoredSupplyDomainsFiltersProps {
  filter: TailoredSupplyDomainsFilter;
  onChange: (filter: TailoredSupplyDomainsFilter) => void;
}

export function TailoredSupplyDomainsFilters({
  filter,
  onChange,
}: TailoredSupplyDomainsFiltersProps) {
  const references = useTailoredSupplyReferences();
  return (
    <section
      aria-label={dashboardT('tailoredSupply.filters')}
      className="border-border bg-card grid min-w-0 gap-3 rounded-md border p-3 md:grid-cols-2"
    >
      <AutocompleteMultiSelect
        label={dashboardT('tailoredSupply.publishersFilter')}
        options={toOptions(references.publishers.data ?? [])}
        value={filter.publisherIds}
        onValueChange={(publisherIds) => {
          onChange({ ...filter, publisherIds, page: 0 });
        }}
        loading={references.publishers.isFetching}
        placeholder={dashboardT('tailoredSupply.publishersFilter')}
      />
      <AutocompleteMultiSelect
        label={dashboardT('tailoredSupply.iabFilter')}
        options={toOptions(references.iabCategories.data ?? [])}
        value={filter.iabCategoryIds}
        onValueChange={(iabCategoryIds) => {
          onChange({ ...filter, iabCategoryIds, page: 0 });
        }}
        loading={references.iabCategories.isFetching}
        placeholder={dashboardT('tailoredSupply.iabFilter')}
      />
      {references.publishers.isError || references.iabCategories.isError ? (
        <p role="alert" className="text-destructive text-xs md:col-span-2">
          {dashboardT('tailoredSupply.lookupError')}
        </p>
      ) : null}
    </section>
  );
}

function toOptions(references: readonly TailoredSupplyReference[]) {
  return references.map((reference) => ({
    id: reference.id,
    label: reference.name,
  }));
}
